import Svg, { Path, type SvgProps } from 'react-native-svg'

export function StatementIcon(props: SvgProps) {
  return (
    <Svg
      width={props.width ?? 33}
      height={props.height ?? 32}
      viewBox="0 0 33 32"
      fill="none"
      {...props}
    >
      <Path
        d="M20.5002 2.66675H8.50016C7.79292 2.66675 7.11464 2.9477 6.61454 3.4478C6.11445 3.94789 5.8335 4.62617 5.8335 5.33341V26.6667C5.8335 27.374 6.11445 28.0523 6.61454 28.5524C7.11464 29.0525 7.79292 29.3334 8.50016 29.3334H24.5002C25.2074 29.3334 25.8857 29.0525 26.3858 28.5524C26.8859 28.0523 27.1668 27.374 27.1668 26.6667V9.33341L20.5002 2.66675Z"
        stroke={props.color ?? 'white'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M19.1665 2.66675V8.00008C19.1665 8.70733 19.4475 9.3856 19.9476 9.8857C20.4477 10.3858 21.1259 10.6667 21.8332 10.6667H27.1665"
        stroke={props.color ?? 'white'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M13.8332 12H11.1665"
        stroke={props.color ?? 'white'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M21.8332 17.3333H11.1665"
        stroke={props.color ?? 'white'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M21.8332 22.6667H11.1665"
        stroke={props.color ?? 'white'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}
